import { jsonApiClient } from '@/shared/model';
import { ClientPrincipalData } from '../@types';

const api = jsonApiClient('.auth', false);

export const getUserInfo = (signal?: AbortSignal) => api.get<ClientPrincipalData>('me', { signal });
